<template>
    <client-page>
        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="client-title--xxxl">위드캔복지재단</h2>
                    </div>
                </v-container>
                <v-img src="/images/about/mobile-intro.jpg" alt="" class="d-md-none" />
                <div class="d-none d-md-block">
                    <v-card tile flat img="/images/about/about-intro.jpg" class="about-intro">
                        <v-container class="h-100 d-flex align-center">
                            <v-row>
                                <v-col cols="12">
                                    <v-img max-width="24" src="/images/about/quotes.svg" alt="" />
                                </v-col>
                                <v-col cols="12">
                                    <div class="client-title--lg font-weight-bold font-size-lg-36">
                                        모두가 <span class="primary--text">차별 없이</span> <br />
                                        기본적인 삶의 권리를 <br />
                                        누릴 수 있도록,
                                    </div>
                                </v-col>
                                <v-col cols="12">
                                    <p class="client-title--sm">
                                        위드캔복지재단은 <br />
                                        인간 존중과 전문성을 바탕으로 생애주기별 국내 전문 사회복지사업과 <br class="d-none d-lg-block" />
                                        지속 가능한 발전 목표(SDGs)에 기반한 국제개발협력사업을 수행하는 <br class="d-none d-lg-block" />
                                        글로벌 사회복지 NGO입니다.
                                    </p>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </div>
            </section>

            <section class="client-section pt-0">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="tit tit--md"><span class="primary--text">1989년,</span> 도움이 필요한 이웃과 함께하는 <span class="primary--text">첫걸음</span>을 내딛었습니다</h2>
                        <p class="grey-1--text mt-18 mt-md-24">
                            우리는 인종, 종교, 사상, 지역의 경계를 넘어, 빈곤과 재난, 억압으로 고통받는 이웃들을 위해 <br class="d-none d-lg-block" />
                            사회복지를 실천하고 <strong class="primary--text">지속 가능한 변화</strong>를 만들어 갑니다.
                        </p>
                    </div>
                    <v-img src="/images/about/about.jpg" alt="" class="border-radius-16" />
                </v-container>
            </section>

            <section class="client-section pt-0">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="tit tit--md">
                            위드캔복지재단은 국내와 해외에서 도움이 필요한 모든 이들에게 희망을 전하며, <br class="d-none d-xl-block" />
                            <span class="primary--text">보다 나은 세상을 만들기 위해 앞으로도 함께 나아가겠습니다.</span>
                        </h2>
                    </div>
                    <div class="border-radius-16">
                        <v-row no-gutters>
                            <v-col v-for="(item, index) in purpose" :key="index" cols="12" lg="6">
                                <v-card flat :color="item.color" class="h-100 text-center">
                                    <v-card-title class="justify-center pt-40 pb-lg-24">
                                        <v-row>
                                            <v-col cols="12">
                                                <div class="tit tit--md primary--text text--darken-2">
                                                    {{ item.title }}
                                                </div>
                                            </v-col>
                                            <v-col cols="12">
                                                <div class="tit tit--sm grey-1--text">
                                                    {{ item.subtitle }}
                                                </div>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-row justify="center" class="ma-n2">
                                                    <v-col v-for="dot in 3" :key="dot" cols="auto" class="pa-2">
                                                        <v-avatar size="4" color="primary darken-2" />
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                    <v-card-text class="pb-40">
                                        <p v-html="item.text" class="page-text page-text--lg grey-1--text" />
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </section>
        </div>

        <div class="client-content-wrap grey-fa">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">핵심역량</h2>
                    </div>
                    <v-row justify="center">
                        <v-col v-for="(item, index) in capabilities" :key="index" cols="6" md="4" lg="">
                            <v-card flat class="border-radius-16 h-100">
                                <v-card-title class="pt-lg-40">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-img max-width="80" :src="item.icon" alt="" class="mx-auto" />
                                        </v-col>
                                        <v-col cols="12">
                                            <div class="tit tit--sm text-center primary--text text--darken-2">
                                                {{ item.name }}
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-card-text class="text-center pb-lg-40">
                                    <p v-html="item.text" class="page-text page-text--lg" />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </section>
        </div>

        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap mb-24 mb-lg-32" >
                        <h2 class="section-title">CI 소개</h2>
                        <p class="section-subtitle">
                            위드캔복지재단은 글로벌 NGO로서 협력과 돌봄을 실천하고, 사회적 약자의 권리를 옹호하며, <br class="d-none d-xl-block" />
                            포용적 사회를 위한 네트워크를 구축하는 기관의 정체성을 반영한 표현입니다
                        </p>
                    </div>
                    <v-row justify="center" class="row--xxs">
                        <v-col cols="auto">
                            <v-btn href="/assets/ci/with-can.jpg" download color="#D5DAE3" outlined rounded="pill" width="160">
                                <span class="button-text-color font-size-14">JPG다운로드</span>
                                <v-img src="/images/about/download.svg" alt="" max-width="16" class="ml-4" />
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn href="/assets/ci/with-can.ai" download color="#D5DAE3" outlined rounded="pill" width="160">
                                <span class="button-text-color font-size-14">AI다운로드</span>
                                <v-img src="/images/about/download.svg" alt="" max-width="16" class="ml-4" />
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-card color="#B3B3B3" outlined img="/images/about/grid.jpg" tile flat class="ci-grid">
                        <v-img max-width="438" src="/images/about/logo.svg" alt="" class="mx-auto w-100" />
                    </v-card>

                    <v-row class="row--sm pt-30 pt-lg-40">
                        <v-col cols="12">
                            <div class="tit tit--sm line-height-1"><span class="primary--text">WITH-</span><span class="primary--text text--darken-2">CAN</span></div>
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                        <v-col v-for="i in can" :key="i.cap" cols="12">
                            <v-row align="center" no-gutters>
                                <v-col cols="auto">
                                    <div class="tit tit--sm primary--text">
                                        {{ i.cap }}
                                    </div>
                                </v-col>
                                <v-col>
                                    <p class="page-text page-text--lg">
                                        {{ i.txt }}
                                    </p>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";

export default {
    components: {
        ClientPage,
    },
    data() {
        return {
            purpose: [
                {
                    title: "미션",
                    subtitle: "사람 중심의 복지, 더 나은 세상을 향해",
                    text: "우리는 인류애를 바탕으로 생애주기별 맞춤형 <br class='d-none d-xl-block'>복지사업과 국제협력을 통해 지속 가능한 사회를 만들어갑니다. <br class='d-none d-xl-block'>모든 사람이 차별 없이 기본적인 권리를 누릴 수 있도록 <br class='d-none d-xl-block'>돕는 것이 우리의 사명입니다.",
                    color: "#EFF5E6",
                },
                {
                    title: "비전",
                    subtitle: "전문성과 혁신으로 선도하는 글로벌 사회복지 전문기관",
                    text: "우리는 전문성과 혁신을 바탕으로 복지의 새로운 기준을 제시하며, <br class='d-none d-xl-block'>국내외 취약계층을 위한 포용적이고 지속 가능한 복지 서비스를 제공합니다. <br class='d-none d-xl-block'>나눔과 협력의 가치를 실천하며, 모두가 함께 성장하는 <br class='d-none d-xl-block'>더 나은 미래를 만들어갑니다.",
                    color: "#FFFBE5",
                },
            ],
            capabilities: [
                {
                    icon: "/images/about/capability-1.svg",
                    name: "전문성",
                    text: "복지 분야의 전문성을 <br class='d-none d-sm-block'>바탕으로 최상의 <br class='d-none d-sm-block'>서비스 제공",
                },
                {
                    icon: "/images/about/capability-2.svg",
                    name: "인간존중",
                    text: "모든 개인의 존엄성과 <br class='d-none d-sm-block'>권리를 최우선으로 존중",
                },
                {
                    icon: "/images/about/capability-3.svg",
                    name: "변화와 도전",
                    text: "변화에 유연하게 대응하며 <br class='d-none d-sm-block'>혁신적인 복지 모델 개발",
                },
                {
                    icon: "/images/about/capability-4.svg",
                    name: "투명성",
                    text: "운영의 투명성을 <br class='d-none d-sm-block'>유지하여 신뢰 구축",
                },
                {
                    icon: "/images/about/capability-5.svg",
                    name: "사회연대",
                    text: "공동체와 협력하여 <br class='d-none d-sm-block'>포용적 복지 실현",
                },
            ],
            can: [
                {
                    cap: "C",
                    txt: "ollaboration & Care (협력과 돌봄)",
                },
                {
                    cap: "A",
                    txt: "dvocacy for All (모든 이를 위한 옹호)",
                },
                {
                    cap: "N",
                    txt: "etwork for Inclusion (포용을 위한 네트워크)",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.about-intro {
    padding: 40px 0;
    background-position-x: 0 !important;
}
.button-text-color {
    color: #4f5968;
}
.ci-grid {
    padding: 24px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
}
@media (min-width: 768px) {
    .about-intro {
        height: 609px;
        background-position-x: center !important;
    }
    .ci-grid {
        height: 370px;
        margin-top: 100px;
    }
}
</style>